<template>
  <TimeSelectButton
    v-if="!isAllDay && isEditable"
    :is-editable="isEditable"
    :is-edited="isEdited"
    :is24h-format="is24hFormat"
    :current-time="currentDaytime"
    @update:time="onTimeUpdate"
  />
  <BaseButton
    v-else-if="!isAllDay"
    kind="auxiliary"
    state="disabled"
    :text="formatedEndTime"
  />
</template>
<script lang="ts">
import { format } from "date-fns/format";
import { computed, defineComponent, PropType, toRefs } from "vue";

import type { Locale } from "@ctrl/controller";
import type { Daytime, EventTime } from "@ctrl/controller-rpc";

import BaseButton from "@/components/base/BaseButton.vue";
import { getDaytime } from "@/components/dates";
import { UseSettings } from "@/components/settings/controller/settings";

import TimeSelectButton from "./TimeSelectButton.vue";

export default defineComponent({
  components: {
    BaseButton,
    TimeSelectButton,
  },
  props: {
    eventTime: { type: Object as PropType<EventTime>, required: true },
    isCompact: { type: Boolean, required: true },
    isDifferentDayPickable: { type: Boolean, required: true },
    isEditable: { type: Boolean, required: true },
    isEdited: { type: Boolean, required: true },
    isEndDifferentFromStart: { type: Boolean, required: true },
    isEndShown: { type: Boolean, required: true },
    locale: { type: Object as PropType<Locale>, required: true },
  },
  emits: {
    "update:endTime": (_time: Daytime) => true,
  },
  setup(props, { emit }) {
    const { eventTime, locale } = toRefs(props);
    const { is24hFormat } = UseSettings.getInstance();

    const isAllDay = computed(() => !("start_time" in eventTime.value));

    const formatedEndTime = computed<string>(() => {
      if ("end_time" in eventTime.value) {
        return locale.value.formatDaytime(getDaytime(eventTime.value.end_time));
      }
      return "";
    });

    const currentDaytime = computed<
      { hours: number; minutes: number } | undefined
    >(() => {
      if ("end_time" in eventTime.value) {
        const daytime = getDaytime(eventTime.value.end_time);
        return {
          hours: daytime.hours,
          minutes: daytime.minutes || 0,
        };
      }
      return undefined;
    });

    const formatDay = (time: Date) => {
      return format(time, "EEE, LLL dd");
    };

    const endDay = computed<Date>(
      // @ts-ignore
      () => eventTime.value.end_date || eventTime.value.date
    );

    const formatedEndDay = computed<string>(() => formatDay(endDay.value));

    const onTimeUpdate = (time: Daytime) => {
      emit("update:endTime", time);
    };

    return {
      currentDaytime,
      formatedEndDay,
      formatedEndTime,
      is24hFormat,
      isAllDay,
      onTimeUpdate,
    };
  },
});
</script>
<style lang="scss" scoped></style>
